import { IQuickCommercePincodeListResponseData } from "@/api_framework/api_modals/QuickCommerce";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type QuickCommerceStateKeys =
    | "pincodeList"

export interface IQuickCommerceListState {
    pincodeList: IQuickCommercePincodeListResponseData[] | null;
}

export interface IQuickCommerceListInitialState extends IRouteReducerSliceStateInit {
    state: IQuickCommerceListState;
}

const initialState: IQuickCommerceListInitialState = {
    state: {
        pincodeList: []
    }
};

const quickCommerceSlice = createSlice({
    name: "quick_commerce_slice",
    initialState: initialState,
    reducers: {
        setPincodeList: (
            state,
            action: PayloadAction<{
              data: IQuickCommercePincodeListResponseData[];
            }>,
          ) => {
            state.state.pincodeList = action.payload.data;
        },
    }
});

export const {
    setPincodeList
} = quickCommerceSlice.actions;
export default quickCommerceSlice.reducer;
  
